import { computed } from 'vue';
import state from '../';

export const disabled = computed(() =>
    !state.loaded
    || state.rigid_move_manipulator
    || state.setting_symmetry_plane
    || state.setting_mirror_plane
    || state.selecting_tangent_perpendicular_plane
    || state.adding_vertex
    || state.currently_loading_model
    || state.editing_reference_partstudio
    || state.editing_reference_sketches
    || state.editing_reference_stl
    || state.offset_face_selecting_vertex
    || state.offset_face_dragging
    || uid_raynode != uid_objects_raynode
);
